import { useMemo } from "react";
import PurchaseOrderDetail from "../PurchaseOrderDetail/PurchaseOrderDetail";
import { useLocation, useMatch, useNavigate } from "react-router-dom";
import { useAppContextNonNull } from "@contexts/AppContext";
import { hasEditAccess, hasReadAccess } from "@services/ScreenOptionsService";
import ISupplierSettings from "@models/ISupplierSettings";
import ViewAccessService from "@services/ViewAccessService";

type Props = {};

export const PurchaseOrderDetailWrapper = (props: Props) => {
    const { userModel, supplierModel, socket, uiContext } = useAppContextNonNull();

    const navigate = useNavigate();
    const location = useLocation();
    const match = useMatch("/purchase_orders/:guid");

    const isReadOnly = useMemo(() => {
        return !hasEditAccess(
            "purchase_orders" as keyof ISupplierSettings["screen_options"],
            userModel,
            supplierModel,
            ViewAccessService.PurchaseOrders
        );
    }, [userModel, supplierModel]);

    return (
        <PurchaseOrderDetail
            setActivityIndicator={uiContext.setActivityIndicator}
            setSidebarComponent={uiContext.setSidebarComponent}
            toggleSidebar={uiContext.toggleSidebar}
            socket={socket}
            notifyFn={uiContext.notifyFn}
            userModel={userModel}
            supplierModel={supplierModel}
            history={navigate}
            location={location}
            match={match}
            isReadOnly={isReadOnly}
            uiContext={uiContext}
        />
    );
};
